/* tslint:disable */
/* eslint-disable */
/**
 * DFB FANCLUB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CircularListResponseDTO
 */
export interface CircularListResponseDTO {
    /**
     * The technical id.
     * 
     * @type {number}
     * @memberof CircularListResponseDTO
     */
    id?: number;
    /**
     * The title of the circular
     * 
     * @type {string}
     * @memberof CircularListResponseDTO
     */
    title?: string;
    /**
     * The timestamp when the circular have been saved
     * 
     * @type {Date}
     * @memberof CircularListResponseDTO
     */
    createdAt?: Date;
    /**
     * The timestamp when the circular have been sent
     * 
     * @type {Date}
     * @memberof CircularListResponseDTO
     */
    sentAt?: Date;
}

/**
 * Check if a given object implements the CircularListResponseDTO interface.
 */
export function instanceOfCircularListResponseDTO(value: object): value is CircularListResponseDTO {
    return true;
}

export function CircularListResponseDTOFromJSON(json: any): CircularListResponseDTO {
    return CircularListResponseDTOFromJSONTyped(json, false);
}

export function CircularListResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CircularListResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'sentAt': json['sentAt'] == null ? undefined : (new Date(json['sentAt'])),
    };
}

export function CircularListResponseDTOToJSON(value?: CircularListResponseDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'title': value['title'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'sentAt': value['sentAt'] == null ? undefined : ((value['sentAt']).toISOString()),
    };
}

